import { styled } from '@mui/material'
import React from 'react';

interface ComponentProps {
    status: boolean;
}

const ViewRouteContent: React.FC<ComponentProps> = ({ status }) => {
  return (
        <StyledContainer>
        <StyledWrapper>
            <StyledText>Status</StyledText>
            {status ? <Active>Active</Active> : <Disabled>Disabled</Disabled>}
        </StyledWrapper>
        <StyledWrapper>
            <StyledText>Date Created</StyledText>
            <StyledDate>March 23 2023</StyledDate>
        </StyledWrapper>
    </StyledContainer>
  )
}

export default ViewRouteContent

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 1.6rem;
    font-weight: 400;
    color: #4E5A62;
`

const Active = styled('span')`
    font-size: 1.2rem;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const Disabled = styled('span')`
    font-size: 1rem;
    font-weight: 500;
    background-color: #FAE0E0;
    border-radius: 0.4rem;
    padding-inline: 0.5rem;
    color: #DD5151;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`